import ApiError from '~/types/ApiError';

const LOAD_ERROR_REASONS: Record<number, string> = {
  403: 'you need a contracting role',
  404: 'the Account is not in Salesforce',
  502: 'Salesforce refused the request for this Account',
  503: 'Salesforce is unavailable, try again in a moment',
};

export function accountLoadErrorReason(error: Error): string {
  const status = error instanceof ApiError ? error.status : undefined;
  return (status && LOAD_ERROR_REASONS[status]) || error.message;
}
